export default __webpack_public_path__ + "media/images/cta_blocks/publish_wedding_website-69cc1707f8d38ed9e131f8f5792dad1a.jpg";